import { apiFetch } from '../api';



import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/FeePaymentEntry.css';

const getLocalDateISO = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatDateDDMMYYYY = (isoDate) => {
  if (!isoDate) return '';
  const datePart = String(isoDate).split('T')[0].split(' ')[0];
  const parts = datePart.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return isoDate;
};

const FeePaymentEntry = () => {
  const { state } = useLocation();
  const studentId = state?.selectedStudent;
  const [isTuitionPaid, setIsTuitionPaid] = useState(false);
  const [isVanPaid, setIsVanPaid] = useState(false);
  const [isOldFeePaid, setIsOldFeePaid] = useState(false);
  
  const [student, setStudent] = useState(null);
  const [paymentData, setPaymentData] = useState({ amount: '', mode: '', transactionId: '', paymentDate: getLocalDateISO() });
  const [vanPayment, setVanPayment] = useState({ amount: '', mode: '', transactionId: '', paymentDate: getLocalDateISO() });
  const [otherPayment, setOtherPayment] = useState({ amount: '', mode: '', transactionId: '' });
  const [oldFeeDues, setOldFeeDues] = useState({ amount: '' });
  const [oldFeePayment, setOldFeePayment] = useState({ amount: '', mode: '', transactionId: '' });

  const [receiptData, setReceiptData] = useState({
    Date: new Date().toISOString().split('T')[0],
    Name: '',
    FatherName: '',
    ClassName: '',
    Admission: '',
    Book: '',
    Uniform: '',
    IdCard: '',
    Tuition: '',
    Exam: '',
    Van: '',
    Others: '',
    Total: ''
  });

  const [transactionHistory, setTransactionHistory] = useState([]);

  const fetchStudentDetails = () => {
    apiFetch(`get_student_details.php?id=${studentId}`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        setStudent(data);
        setReceiptData(prev => ({
          ...prev,
          Name: data.full_name,
          FatherName: data.father_name,
          ClassName: data.class_name
        }));
      })
      .catch(err => {
        console.error("Error fetching student details:", err);
      });
  };

  const fetchTransactionHistory = () => {
    if (studentId) {
      apiFetch(`get_student_transaction_history.php?student_id=${studentId}`, {
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
          }
          return res.json();
        })
        .then(data => {
          console.log("Transaction history response:", data); // Debug log
          if (Array.isArray(data)) {
            console.log("Setting transaction history with", data.length, "transactions"); // Debug log
            setTransactionHistory(data);
          } else {
            console.error("Transaction history data is not an array:", data);
            setTransactionHistory([]);
          }
        })
        .catch(err => {
          console.error("Error fetching transaction history:", err);
          setTransactionHistory([]);
        });
    }
  };

  useEffect(() => {
    fetchStudentDetails();
    fetchTransactionHistory();
  }, [studentId]);

  const handleChange = (e) => {
    setPaymentData({ ...paymentData, [e.target.name]: e.target.value });
  };

  const handleVanChange = (e) => {
    setVanPayment({ ...vanPayment, [e.target.name]: e.target.value });
  };

  const handleOtherChange = (e) => {
    setOtherPayment({ ...otherPayment, [e.target.name]: e.target.value });
  };

  const handleOldFeeDuesChange = (e) => {
    setOldFeeDues({ ...oldFeeDues, [e.target.name]: e.target.value });
  };

  const handleOldFeePaymentChange = (e) => {
    setOldFeePayment({ ...oldFeePayment, [e.target.name]: e.target.value });
  };

  const handleReceiptChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...receiptData, [name]: value };

    const feeFields = ['Admission', 'Book', 'Uniform', 'IdCard', 'Tuition', 'Exam', 'Van', 'Others'];
    const total = feeFields.reduce((sum, field) => {
      const val = parseFloat(updated[field]);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);

    updated.Total = total;
    setReceiptData(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!student) {
      alert("Student data is not loaded.");
      return;
    }
  
    if (student.pending_tuition_fee <= 0) {
      alert("No pending tuition fee.");
      return;
    }
  
    const enteredAmount = parseFloat(paymentData.amount);
    if (!enteredAmount || enteredAmount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    if (!paymentData.paymentDate) {
      alert("Please select a payment date.");
      return;
    }
  
    if (enteredAmount > student.tuition_fee) {
      alert("Amount exceeds tuition fee.");
      return;
    }
  
    apiFetch('save_payment.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ...paymentData, studentId })
    })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
        console.log("Tuition payment response:", data); // ✅ Debug
        if (data.success) {
          const updatedPayment = {
            ...paymentData,
            bill_number: data.bill_number
          };
          setPaymentData(updatedPayment);
          setIsTuitionPaid(true);
          alert(data.message);
          
          // Refresh transaction history after payment
          if (studentId) {
            apiFetch(`get_student_transaction_history.php?student_id=${studentId}`, {
              credentials: 'include'
            })
              .then(res => res.json())
              .then(data => {
                if (Array.isArray(data)) {
                  setTransactionHistory(data);
                }
              })
              .catch(err => {
                console.error("Error fetching transaction history:", err);
              });
          }
        } else {
          alert(data.message);
        }
      })
      .catch(err => {
        console.error("Fetch failed:", err);
        alert("Something went wrong saving the payment.");
      });
  };
  
      
  
  const submitVanPayment = (e) => {
    e.preventDefault();
    if (student.pending_van_fee <= 0) {
      alert("No pending van fee.");
      return;
    }
    if (parseFloat(vanPayment.amount) > student.van_fee) {
      alert("Amount exceeds van fee.");
      return;
    }
    if (!vanPayment.paymentDate) {
      alert("Please select a payment date.");
      return;
    }
  
    apiFetch('save_van_payment.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ...vanPayment, studentId })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        alert(data.message);
        setVanPayment(prev => ({
          ...prev,
          bill_number: data.bill_number
        }));
        setIsVanPaid(true);
        
        // Refresh transaction history after payment
        if (studentId) {
          apiFetch(`get_student_transaction_history.php?student_id=${studentId}`, {
            credentials: 'include'
          })
            .then(res => res.json())
            .then(data => {
              if (Array.isArray(data)) {
                setTransactionHistory(data);
              }
            })
            .catch(err => {
              console.error("Error fetching transaction history:", err);
            });
        }
      } else {
        alert(data.message);
      }
    });
    
  };
    
  const submitOtherPayment = (e) => {
    e.preventDefault();
  
    apiFetch('save_other_payment.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ...otherPayment, studentId })
    })
      .then(res => res.json()) // ✅ Parse as JSON
      .then(data => {
        if (data.success) {
          alert(data.message);
          setOtherPayment(prev => ({
            ...prev,
            bill_number: data.bill_number // ✅ Save bill number for print
          }));
        } else {
          alert(data.message);
        }
      })
      .catch(err => {
        console.error("Error saving other fee payment:", err);
        alert("An error occurred while saving payment.");
      });
  };

  const submitOldFeeDues = (e) => {
    e.preventDefault();
    
    if (!student) {
      alert("Student data is not loaded.");
      return;
    }

    const amount = parseFloat(oldFeeDues.amount);
    if (!amount || amount <= 0) {
      alert("Please enter a valid old fee amount.");
      return;
    }

    apiFetch('save_old_fee_dues.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ studentId, oldFeeAmount: amount })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          alert(data.message);
          setOldFeeDues({ amount: '' });
          fetchStudentDetails(); // Refresh student details to show old fee due
        } else {
          alert(data.message);
        }
      })
      .catch(err => {
        console.error("Error saving old fee dues:", err);
        alert("An error occurred while saving old fee dues.");
      });
  };

  const submitOldFeePayment = (e) => {
    e.preventDefault();
    
    if (!student) {
      alert("Student data is not loaded.");
      return;
    }

    if (!student.old_fee_due || student.old_fee_due <= 0) {
      alert("No old fee dues found. Please add old fee dues first.");
      return;
    }

    const enteredAmount = parseFloat(oldFeePayment.amount);
    if (!enteredAmount || enteredAmount <= 0) {
      alert("Please enter a valid amount.");
      return;
    }

    if (enteredAmount > (student.old_fee_pending_due || 0)) {
      alert("Amount exceeds pending old fee dues.");
      return;
    }

    apiFetch('save_old_fee_payment.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ ...oldFeePayment, studentId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          alert(data.message);
          setOldFeePayment(prev => ({
            ...prev,
            bill_number: data.bill_number
          }));
          setIsOldFeePaid(true);
          fetchStudentDetails(); // Refresh student details to show updated pending due
          fetchTransactionHistory(); // Refresh transaction history after payment
        } else {
          alert(data.message);
        }
      })
      .catch(err => {
        console.error("Error saving old fee payment:", err);
        alert("An error occurred while saving payment.");
      });
  };
  
  const printReceipt = (receiptData) => {
  let lastBillNumber = parseInt(localStorage.getItem('lastBillNumber') || '1000', 10);
  const currentBillNumber = lastBillNumber + 1;
  localStorage.setItem('lastBillNumber', currentBillNumber);

  const billContent = `
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 0;
        font-size: 12px;
      }
      .print-button {
        display: block;
        margin: 10px auto;
        padding: 5px 15px;
        font-size: 14px;
        cursor: pointer;
      }
      @media print {
        .print-button {
          display: none;
        }
      }
      .page {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        padding: 15mm;
        box-sizing: border-box;
      }
      .bill {
        width: 48%;
        border: 1px solid #000;
        padding: 15px;
        box-sizing: border-box;
      }
      .bill-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
      }
      .bill-header img {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      .bill-title {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.4;
      }
      .bill-sub-header {
        text-align: center;
        font-size: 11px;
        margin-bottom: 8px;
      }
      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      .field {
        flex: 1;
      }
      .table {
        width: 100%;
        margin-top: 10px;
        border-collapse: collapse;
      }
      .table th,
      .table td {
        border: 1px solid #000;
        padding: 6px 8px;
        text-align: left;
      }
      .sign {
        text-align: right;
        margin-top: 25px;
        font-size: 11px;
      }
    </style>

    <button class="print-button" onclick="window.print()">Print</button>
    <div class="page">
      ${[1, 2].map(() => `
        <div class="bill">
          <div class="bill-header">
            <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
            <div class="bill-title">
              OXFORD CONVENT<br>
              ENGLISH MEDIUM SCHOOL, KHAJURI
            </div>
          </div>

          <div class="bill-sub-header">
            KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
            <div><strong>Other Bill No: ${currentBillNumber}</strong></div>
            <strong>FEES RECEIPT</strong>
          </div>

          <div class="row">
            <div class="field">Name: ${receiptData.Name}</div>
            <div class="field" style="text-align: right;">Date: ${receiptData.Date}</div>
          </div>
          <div class="row">
            <div class="field">Father Name: ${receiptData.FatherName}</div>
            <div class="field" style="text-align: right;">Class: ${receiptData.ClassName}</div>
          </div>

          <table class="table">
            <tr><th>Particulars</th><th>Amount</th></tr>
            <tr><td>Admission Fees</td><td>${receiptData.Admission}</td></tr>
            <tr><td>Book Fees</td><td>${receiptData.Book}</td></tr>
            <tr><td>Uniform Fees</td><td>${receiptData.Uniform}</td></tr>
            <tr><td>Belt, Tie, & ID Card Fees</td><td>${receiptData.IdCard}</td></tr>
            <tr><td>Tuition / Library Fees</td><td>${receiptData.Tuition}</td></tr>
            <tr><td>Exam Fees</td><td>${receiptData.Exam}</td></tr>
            <tr><td>School Van Fees</td><td>${receiptData.Van}</td></tr>
            <tr><td>Others</td><td>${receiptData.Others}</td></tr>
          </table>

          <div class="row">
            <div class="field" style="font-size: 14px; font-weight: bold;">
              Total Fees: ₹${receiptData.Total}
            </div>
          </div>

          <div class="sign">Sign of Cashier/H.M</div>
        </div>
      `).join('')}
    </div>
  `;

  const billWindow = window.open('', '', 'height=800,width=1200');
  billWindow.document.write('<html><head><title>Fees Receipt</title></head><body>');
  billWindow.document.write(billContent);
  billWindow.document.write('</body></html>');
  billWindow.document.close();

  billWindow.onload = () => {
    const images = billWindow.document.images;
    let loadedCount = 0;

    if (images.length === 0) return;

    for (let img of images) {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          // All images loaded, user can now print
        }
      };
    }
  };
};


  const printTuitionBill = () => {
  const today = formatDateDDMMYYYY(paymentData.paymentDate || getLocalDateISO());

  const amount = paymentData.amount;
  const billNumber = paymentData.bill_number;
  const outstandingBalance = Math.max(0, (student.pending_tuition_fee || 0) - parseFloat(amount || 0));

  const content = `
    <style>
      body {
        font-family: Arial;
        font-size: 12px;
        margin: 0;
      }
      .print-button {
        display: block;
        margin: 10px auto;
        padding: 5px 15px;
        font-size: 14px;
        cursor: pointer;
      }
      @media print {
        .print-button {
          display: none;
        }
      }
      .page {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        padding: 15mm;
        box-sizing: border-box;
      }
      .bill {
        width: 48%;
        border: 1px solid #000;
        padding: 15px;
        box-sizing: border-box;
      }
      .bill-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
      }
      .bill-header img {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      .bill-title {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.4;
      }
      .bill-sub-header {
        text-align: center;
        font-size: 11px;
        margin-bottom: 12px;
      }
      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      .table {
        width: 100%;
        margin-top: 10px;
        border-collapse: collapse;
      }
      .table th, .table td {
        border: 1px solid #000;
        padding: 6px 8px;
        text-align: left;
      }
      .sign {
        text-align: right;
        margin-top: 25px;
        font-size: 11px;
      }
    </style>

    <button class="print-button" onclick="window.print()">Print</button>
    <div class="page">
      ${[1, 2].map(() => `
        <div class="bill">
          <div class="bill-header">
            <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
            <div class="bill-title">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
          </div>
          <div class="bill-sub-header">
            KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
            <strong>TUITION FEE RECEIPT</strong><br>
            <div><strong>FEE Bill No: ${billNumber}</strong></div>
          </div>
          <div class="row"><div>Name: ${student.full_name}</div><div>Date: ${today}</div></div>
          <div class="row"><div>Father's Name: ${student.father_name}</div><div>Class: ${student.class_name}</div></div>
          <table class="table">
            <tr><th>Particulars</th><th>Amount</th></tr>
            <tr><td>Tuition Fee Paid</td><td>₹${amount}</td></tr>
            <tr><td>Outstanding Balance (Pending Tuition Fees)</td><td>₹${outstandingBalance.toFixed(2)}</td></tr>
          </table>
          <div class="sign">Sign of Cashier/H.M</div>
        </div>
      `).join('')}
    </div>
  `;

  const win = window.open('', '', 'height=800,width=1200');
  win.document.write('<html><head><title>Tuition Fee Bill</title></head><body>');
  win.document.write(content);
  win.document.write('</body></html>');
  win.document.close();

  win.onload = () => {
    const images = win.document.images;
    let loadedCount = 0;

    if (images.length === 0) {
      win.print();
      return;
    }

    for (let img of images) {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          win.print();
        }
      };
    }
  };
};
  const printVanBill = () => {
  const today = formatDateDDMMYYYY(vanPayment.paymentDate || getLocalDateISO());

  const amount = vanPayment.amount;
  const billNumber = vanPayment.bill_number;
  const outstandingBalance = Math.max(0, (student.pending_van_fee || 0) - parseFloat(amount || 0));

  const content = `
    <style>
      body {
        font-family: Arial;
        font-size: 12px;
        margin: 0;
      }
      .print-button {
        display: block;
        margin: 10px auto;
        padding: 5px 15px;
        font-size: 14px;
        cursor: pointer;
      }
      @media print {
        .print-button {
          display: none;
        }
      }
      .page {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        padding: 15mm;
        box-sizing: border-box;
      }
      .bill {
        width: 48%;
        border: 1px solid #000;
        padding: 15px;
        box-sizing: border-box;
      }
      .bill-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
      }
      .bill-header img {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      .bill-title {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.4;
      }
      .bill-sub-header {
        text-align: center;
        font-size: 11px;
        margin-bottom: 12px;
      }
      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      .table {
        width: 100%;
        margin-top: 10px;
        border-collapse: collapse;
      }
      .table th, .table td {
        border: 1px solid #000;
        padding: 6px 8px;
        text-align: left;
      }
      .sign {
        text-align: right;
        margin-top: 25px;
        font-size: 11px;
      }
    </style>

    <button class="print-button" onclick="window.print()">Print</button>
    <div class="page">
      ${[1, 2].map(() => `
        <div class="bill">
          <div class="bill-header">
            <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
            <div class="bill-title">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
          </div>
          <div class="bill-sub-header">
            KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
            <strong>VAN FEE RECEIPT</strong><br>
            <div><strong>Van Bill No: ${billNumber}</strong></div>
          </div>
          <div class="row"><div>Name: ${student.full_name}</div><div>Date: ${today}</div></div>
          <div class="row"><div>Father's Name: ${student.father_name}</div><div>Class: ${student.class_name}</div></div>
          <table class="table">
            <tr><th>Particulars</th><th>Amount</th></tr>
            <tr><td>Van Fee Paid</td><td>₹${amount}</td></tr>
            <tr><td>Outstanding Balance (Pending Van Fees)</td><td>₹${outstandingBalance.toFixed(2)}</td></tr>
          </table>
          <div class="sign">Sign of Cashier/H.M</div>
        </div>
      `).join('')}
    </div>
  `;

  const win = window.open('', '', 'height=800,width=1200');
  win.document.write('<html><head><title>Van Fee Bill</title></head><body>');
  win.document.write(content);
  win.document.write('</body></html>');
  win.document.close();

  win.onload = () => {
    const images = win.document.images;
    let loadedCount = 0;

    if (images.length === 0) return;

    for (let img of images) {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          // All images loaded, user can print
        }
      };
    }
  };
};

  const printOldFeeBill = () => {
    const today = (() => {
      const d = new Date();
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    })();

    const amount = oldFeePayment.amount;
    const billNumber = oldFeePayment.bill_number;
    // outstandingBalance is already calculated correctly in student.old_fee_pending_due (after this payment)
    const outstandingBalance = Math.max(0, student.old_fee_pending_due || 0);

    const content = `
      <style>
        body {
          font-family: Arial;
          font-size: 12px;
          margin: 0;
        }
        .print-button {
          display: block;
          margin: 10px auto;
          padding: 5px 15px;
          font-size: 14px;
          cursor: pointer;
        }
        @media print {
          .print-button {
            display: none;
          }
        }
        .page {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          padding: 15mm;
          box-sizing: border-box;
        }
        .bill {
          width: 48%;
          border: 1px solid #000;
          padding: 15px;
          box-sizing: border-box;
        }
        .bill-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }
        .bill-header img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
        .bill-title {
          flex: 1;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.4;
        }
        .bill-sub-header {
          text-align: center;
          font-size: 11px;
          margin-bottom: 12px;
        }
        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 5px;
        }
        .table {
          width: 100%;
          margin-top: 10px;
          border-collapse: collapse;
        }
        .table th, .table td {
          border: 1px solid #000;
          padding: 6px 8px;
          text-align: left;
        }
        .sign {
          text-align: right;
          margin-top: 25px;
          font-size: 11px;
        }
      </style>

      <button class="print-button" onclick="window.print()">Print</button>
      <div class="page">
        ${[1, 2].map(() => `
          <div class="bill">
            <div class="bill-header">
              <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
              <div class="bill-title">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
            </div>
            <div class="bill-sub-header">
              KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
              <strong>OLD FEE DUES RECEIPT</strong><br>
              <div><strong>Old Fee Bill No: ${billNumber}</strong></div>
            </div>
            <div class="row"><div>Name: ${student.full_name}</div><div>Date: ${today}</div></div>
            <div class="row"><div>Father's Name: ${student.father_name}</div><div>Class: ${student.class_name}</div></div>
            <table class="table">
              <tr><th>Particulars</th><th>Amount</th></tr>
              <tr><td>Old Fee Dues Paid</td><td>₹${amount}</td></tr>
              <tr><td>Outstanding Balance (Pending Old Fee Dues)</td><td>₹${outstandingBalance.toFixed(2)}</td></tr>
            </table>
            <div class="sign">Sign of Cashier/H.M</div>
          </div>
        `).join('')}
      </div>
    `;

    const win = window.open('', '', 'height=800,width=1200');
    win.document.write('<html><head><title>Old Fee Dues Bill</title></head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();

    win.onload = () => {
      const images = win.document.images;
      let loadedCount = 0;

      if (images.length === 0) {
        win.print();
        return;
      }

      for (let img of images) {
        img.onload = img.onerror = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            win.print();
          }
        };
      }
    };
  };

  // Reprint bill function for transaction history
  const reprintBill = (transaction) => {
  if (!student) {
    alert("Student data is not loaded.");
    return;
  }

  const transactionDate = (() => {
    const dateStr = transaction.transaction_date;
    if (dateStr) {
      // Convert YYYY-MM-DD to DD-MM-YYYY
      const parts = dateStr.split('-');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return dateStr;
    }
    const d = new Date();
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  })();

  const amount = transaction.amount;
  const billNumber = transaction.bill_number;
  const isTuitionFee = transaction.payment_type === 'Tuition fee';
  const isVanFee = transaction.payment_type === 'Van fee';
  const isOldFee = transaction.payment_type === 'Old fee dues';
  
  // Calculate outstanding balance after this specific transaction
  // Start with current pending balance and add back payments made after this transaction
  let outstandingBalance = 0;
  if (isTuitionFee) {
    outstandingBalance = student.pending_tuition_fee || 0;
  } else if (isVanFee) {
    outstandingBalance = student.pending_van_fee || 0;
  } else if (isOldFee) {
    outstandingBalance = student.old_fee_pending_due || 0;
  }
  
  // Add back payments of the same type made after this transaction
  if (transactionHistory && transactionHistory.length > 0) {
    const currentTransactionDate = new Date(transaction.transaction_date);
    const paymentsAfter = transactionHistory.filter(t => {
      // Filter by payment type
      if (isTuitionFee && t.payment_type !== 'Tuition fee') return false;
      if (isVanFee && t.payment_type !== 'Van fee') return false;
      if (isOldFee && t.payment_type !== 'Old fee dues') return false;
      // Check if this transaction is after the one we're reprinting
      const tDate = new Date(t.transaction_date);
      return tDate > currentTransactionDate || (tDate.getTime() === currentTransactionDate.getTime() && t.bill_number > billNumber);
    });
    
    const totalPaidAfter = paymentsAfter.reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
    outstandingBalance = outstandingBalance + totalPaidAfter;
  }
  
  outstandingBalance = Math.max(0, outstandingBalance);

  const content = `
    <style>
      body {
        font-family: Arial;
        font-size: 12px;
        margin: 0;
      }
      .print-button {
        display: block;
        margin: 10px auto;
        padding: 5px 15px;
        font-size: 14px;
        cursor: pointer;
      }
      @media print {
        .print-button {
          display: none;
        }
      }
      .page {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        padding: 15mm;
        box-sizing: border-box;
      }
      .bill {
        width: 48%;
        border: 1px solid #000;
        padding: 15px;
        box-sizing: border-box;
      }
      .bill-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
      }
      .bill-header img {
        width: 50px;
        height: 50px;
        object-fit: contain;
      }
      .bill-title {
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.4;
      }
      .bill-sub-header {
        text-align: center;
        font-size: 11px;
        margin-bottom: 12px;
      }
      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      .table {
        width: 100%;
        margin-top: 10px;
        border-collapse: collapse;
      }
      .table th, .table td {
        border: 1px solid #000;
        padding: 6px 8px;
        text-align: left;
      }
      .sign {
        text-align: right;
        margin-top: 25px;
        font-size: 11px;
      }
    </style>

    <button class="print-button" onclick="window.print()">Print</button>
    <div class="page">
      ${[1, 2].map(() => `
        <div class="bill">
          <div class="bill-header">
            <img src="${window.location.origin}/school-logo.jpg" alt="Logo" />
            <div class="bill-title">OXFORD CONVENT<br>ENGLISH MEDIUM SCHOOL, KHAJURI</div>
          </div>
          <div class="bill-sub-header">
            KHAJURI - 585 314 - Tq. Aland Dist. Kalaburagi<br>
            <strong>${isTuitionFee ? 'TUITION FEE RECEIPT' : isVanFee ? 'VAN FEE RECEIPT' : 'OLD FEE DUES RECEIPT'}</strong><br>
            <div><strong>${isTuitionFee ? 'FEE' : isVanFee ? 'Van' : 'Old Fee'} Bill No: ${billNumber}</strong></div>
          </div>
          <div class="row"><div>Name: ${student.full_name}</div><div>Date: ${transactionDate}</div></div>
          <div class="row"><div>Father's Name: ${student.father_name}</div><div>Class: ${student.class_name}</div></div>
          <table class="table">
            <tr><th>Particulars</th><th>Amount</th></tr>
            <tr><td>${isTuitionFee ? 'Tuition Fee Paid' : isVanFee ? 'Van Fee Paid' : 'Old Fee Dues Paid'}</td><td>₹${amount}</td></tr>
            <tr><td>Outstanding Balance (Pending ${isTuitionFee ? 'Tuition' : isVanFee ? 'Van' : 'Old Fee'} Fees)</td><td>₹${outstandingBalance.toFixed(2)}</td></tr>
          </table>
          <div class="sign">Sign of Cashier/H.M</div>
        </div>
      `).join('')}
    </div>
  `;

  const win = window.open('', '', 'height=800,width=1200');
  win.document.write(`<html><head><title>${isTuitionFee ? 'Tuition Fee Bill' : isVanFee ? 'Van Fee Bill' : 'Old Fee Dues Bill'}</title></head><body>`);
  win.document.write(content);
  win.document.write('</body></html>');
  win.document.close();

  win.onload = () => {
    const images = win.document.images;
    let loadedCount = 0;

    if (images.length === 0) {
      win.print();
      return;
    }

    for (let img of images) {
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          win.print();
        }
      };
    }
  };
};

  

  if (!student) return <div className="fpe-loading">Loading student data...</div>;

  return (
    <div className="fpe-container">
      <div className="fpe-card">
        <h2>Student Details</h2>
        <p><strong>Full Name:</strong> {student.full_name}</p>
        <p><strong>DOB:</strong> {student.dob}</p>
        <p><strong>Age:</strong> {student.age}</p>
        <p><strong>Class:</strong> {student.class_name}</p>
        <p><strong>Father's Name:</strong> {student.father_name}</p>
        <p><strong>Mother's Name:</strong> {student.mother_name}</p>
        <p><strong>Tuition Fee:</strong> ₹{student.tuition_fee}</p>
        <p><strong>Van Fee:</strong> ₹{student.van_fee}</p>
        <p><strong>Pending Tuition Fee:</strong> ₹{student.pending_tuition_fee}</p>
        <p><strong>Pending Van Fee:</strong> ₹{student.pending_van_fee}</p>
        {student.old_fee_due !== undefined && (
          <p><strong>Old Fees due:</strong> ₹{student.old_fee_due || 0}</p>
        )}
        {student.old_fee_pending_due !== undefined && (
          <p><strong>Old Fees pending due:</strong> ₹{student.old_fee_pending_due || 0}</p>
        )}
      </div>
      <form onSubmit={handleSubmit} className="fpe-card fpe-form">
  <h3>Fee Payment</h3>
  <input
    type="date"
    name="paymentDate"
    value={paymentData.paymentDate}
    required
    onChange={handleChange}
  />
  <input
    type="number"
    name="amount"
    placeholder="Amount"
    min="0"
    required
    onChange={handleChange}
  />

  <select
    name="mode"
    required
    value={paymentData.mode}
    onChange={handleChange}
  >
    <option value="">Select Transaction Mode</option>
    <option value="Cash">Cash</option>
    <option value="UPI">UPI</option>
    <option value="Concession">Concession</option> {/* New option added */}
  </select>

  <input
    type="text"
    name="transactionId"
    placeholder="Transaction ID"
    required
    onChange={handleChange}
  />

  <div style={{ display: 'flex', gap: '10px' }}>
    <button type="submit">Save Fee Payment</button>
    <button type="button" onClick={printTuitionBill} disabled={!isTuitionPaid}>
      Bill
    </button>
  </div>
</form>



<form onSubmit={submitVanPayment} className="fpe-card fpe-form">
  <h3>Van Fees</h3>
  <input
    type="date"
    name="paymentDate"
    value={vanPayment.paymentDate}
    required
    onChange={handleVanChange}
  />
  <input
    type="number"
    name="amount"
    placeholder="Amount"
    min="0"
    required
    onChange={handleVanChange}
  />

  <select
    name="mode"
    required
    value={vanPayment.mode}
    onChange={handleVanChange}
  >
    <option value="">Select Transaction Mode</option>
    <option value="Cash">Cash</option>
    <option value="UPI">UPI</option>
    <option value="Concession">Concession</option> {/* New option added */}
  </select>

  <input
    type="text"
    name="transactionId"
    placeholder="Transaction ID"
    required
    onChange={handleVanChange}
  />

  <div style={{ display: 'flex', gap: '10px' }}>
    <button type="submit">Save Van Fee</button>
    <button type="button" onClick={printVanBill} disabled={!isVanPaid}>
      Bill
    </button>
  </div>
</form>

<form onSubmit={submitOldFeeDues} className="fpe-card fpe-form">
  <h3>Add Old fee dues</h3>
  <input
    type="number"
    name="amount"
    placeholder="Old fee dues amount"
    min="0"
    step="0.01"
    required
    value={oldFeeDues.amount}
    onChange={handleOldFeeDuesChange}
  />
  <button type="submit">Save</button>
</form>

<form onSubmit={submitOldFeePayment} className="fpe-card fpe-form">
  <h3>Pay old fee dues</h3>
  <input
    type="number"
    name="amount"
    placeholder="Amount"
    min="0"
    step="0.01"
    required
    value={oldFeePayment.amount}
    onChange={handleOldFeePaymentChange}
  />

  <select
    name="mode"
    required
    value={oldFeePayment.mode}
    onChange={handleOldFeePaymentChange}
  >
    <option value="">Select Transaction Mode</option>
    <option value="Cash">Cash</option>
    <option value="UPI">UPI</option>
    <option value="Concession">Concession</option>
  </select>

  <input
    type="text"
    name="transactionId"
    placeholder="Transaction ID"
    required
    value={oldFeePayment.transactionId}
    onChange={handleOldFeePaymentChange}
  />

  <div style={{ display: 'flex', gap: '10px' }}>
    <button type="submit">Save Old fee</button>
    <button type="button" onClick={printOldFeeBill} disabled={!isOldFeePaid}>
      Bill
    </button>
  </div>
</form>

<div className="fpe-card fpe-form">
  <h3>Transaction History</h3>
  <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
    <thead>
      <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #ddd' }}>
        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Sl No</th>
        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Transaction Date</th>
        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Transaction Amount</th>
        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Type of Payment</th>
        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>Reprint Bill</th>
      </tr>
    </thead>
    <tbody>
      {transactionHistory.length === 0 ? (
        <tr>
          <td colSpan="5" style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
            No transaction history found
          </td>
        </tr>
      ) : (
        transactionHistory.map((transaction, index) => {
          // Format date from YYYY-MM-DD to DD-MM-YYYY
          const formatDate = (dateStr) => {
            if (!dateStr) return '';
            const parts = dateStr.split('-');
            if (parts.length === 3) {
              return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr;
          };

          return (
            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{index + 1}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{formatDate(transaction.transaction_date)}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>₹{transaction.amount}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{transaction.payment_type}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                <button
                  type="button"
                  onClick={() => reprintBill(transaction)}
                  style={{
                    padding: '5px 15px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Reprint
                </button>
              </td>
            </tr>
          );
        })
      )}
    </tbody>
  </table>
</div>

<form onSubmit={submitOtherPayment} className="fpe-card fpe-form">
  <h3>Other Fees</h3>

  <input
    type="number"
    name="amount"
    placeholder="Amount"
    min="0"
    required
    onChange={handleOtherChange}
  />

  <select
    name="mode"
    required
    value={otherPayment.mode}
    onChange={handleOtherChange}
  >
    <option value="">Select Transaction Mode</option>
    <option value="Cash">Cash</option>
    <option value="UPI">UPI</option>
  </select>

  <input
    type="text"
    name="transactionId"
    placeholder="Transaction ID"
    required
    onChange={handleOtherChange}
  />

  <button type="submit">Save Other Fee</button>
</form>


      <div className="fpe-card fpe-form">
        <h3>Receipt Details</h3>
        {Object.keys(receiptData).map((key) => key === 'Total' ? null : (
          <div key={key} className="fpe-field">
            <label>{key}</label>
            <input name={key} value={receiptData[key]} onChange={handleReceiptChange} type={key === 'Date' ? 'date' : 'text'} />
          </div>
        ))}
        <div className="fpe-field">
          <label>Total</label>
          <input name="Total" value={receiptData.Total} readOnly />
        </div>
        <button onClick={() => printReceipt(receiptData)} type="button">Print Receipt</button>
      </div>
    </div>
  );
};

export default FeePaymentEntry;